"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyModal = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var changeActions = require("@caddigital/sok-reducers/lib/actions/project/change");
var wizardActions = require("@caddigital/sok-reducers/lib/actions/project/wizard");
var CompanySelect_1 = require("./components/CompanySelect");
var CompanyRadioButtons_1 = require("./components/CompanyRadioButtons");
var FooterButtons_1 = require("./components/FooterButtons");
var CustomerContext_1 = require("../../hooks/CustomerContext");
require("./styles.scss");
var CompanyModal = function (_a) {
    var _b;
    var project = _a.project, wizard = _a.wizard, fetchCustomers = _a.fetchCustomers;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.project.change; }), isModalOpen = _c.isModalOpen, fetchStatus = _c.fetchStatus;
    var _d = (0, CustomerContext_1.useCustomer)(), newCustomer = _d.newCustomer, setNewCustomer = _d.setNewCustomer;
    var _e = React.useState(newCustomer || null), selectedCustomer = _e[0], setSelectedCustomer = _e[1];
    var _f = React.useState(false), syncMatchingGroupCategory = _f[0], setSyncMatchingGroupCategory = _f[1];
    var customStyles = {
        menu: function (provided) { return (__assign(__assign({}, provided), { maxHeight: '12rem', overflowY: 'auto' })); }
    };
    var updateCustomer = function (customer) {
        setSelectedCustomer(customer);
    };
    var closeModal = function () {
        dispatch(changeActions.toggleModal());
        dispatch(changeActions.clearAll());
        setSelectedCustomer(null);
    };
    var save = function () {
        var _a;
        if (!selectedCustomer || !project.uuid || !project.customer) {
            return;
        }
        var payload = {
            projectUuid: project.uuid,
            prevCustomerUuid: (newCustomer === null || newCustomer === void 0 ? void 0 : newCustomer.uuid) || ((_a = project.customer) === null || _a === void 0 ? void 0 : _a.uuid),
            newCustomerUuid: selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.uuid,
            syncMatchingGroupCategoryLinksByName: syncMatchingGroupCategory
        };
        dispatch(changeActions.changeCustomerRequest(payload));
    };
    var handleRadioChange = function (value) {
        setSyncMatchingGroupCategory(value);
    };
    React.useEffect(function () {
        if (fetchStatus.isSuccess) {
            setNewCustomer({
                name: (selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.name) || '',
                uuid: (selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.uuid) || ''
            });
            dispatch(wizardActions.updateWizardCustomer({
                id: Number(selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.id),
                uuid: (selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.uuid) || '',
                name: (selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.name) || '',
                businessId: (selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.businessId) || '',
                type: 'CUSTOMER'
            }));
            dispatch(changeActions.toggleModal());
            dispatch(changeActions.clearAll());
        }
    }, [fetchStatus]);
    return (React.createElement(sok_ui_1.Modal, { isOpen: isModalOpen, className: 'change-company-modal' },
        React.createElement(sok_ui_1.Header, { className: 'header', onClose: closeModal },
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/projectsTab/editProject/basicInformation/company/modal/header'))),
        React.createElement(sok_ui_1.Container, { className: 'content' },
            React.createElement(CompanySelect_1.CompanySelect, { customStyles: customStyles, selectedCustomer: (_b = selectedCustomer) !== null && _b !== void 0 ? _b : project.customer, updateCustomer: updateCustomer, fetchCustomers: fetchCustomers, wizard: wizard, fetchStatus: fetchStatus }),
            React.createElement(CompanyRadioButtons_1.CompanyRadioButtons, { syncMatchingGroupCategory: syncMatchingGroupCategory, handleRadioChange: handleRadioChange })),
        React.createElement(sok_ui_1.Footer, { className: 'footer' },
            React.createElement(FooterButtons_1.FooterButtons, { save: save, closeModal: closeModal }))));
};
exports.CompanyModal = CompanyModal;
